export default [
  { name: "ground", texture: "./bakedPictures/ground.webp" },
  { name: "statue", texture: "./bakedPictures/statue.webp" },
  { name: "pavement", texture: "./bakedPictures/pavement.webp" },
  { name: "bricks_1", texture: "./bakedPictures/bricks_1.webp" },
  { name: "bricks_2", texture: "./bakedPictures/bricks_2.webp" },
  { name: "bricks_3", texture: "./bakedPictures/bricks_3.webp" },
  { name: "signs", texture: "./bakedPictures/signs.webp" },
  { name: "boardBounds", texture: "./bakedPictures/boardBounds.webp" },
  { name: "pines", texture: "./bakedPictures/pines.webp" },
  { name: "bushes", texture: "./bakedPictures/bushes.webp" },
  { name: "trees_1", texture: "./bakedPictures/trees_1.webp" },
  { name: "trees_2", texture: "./bakedPictures/trees_2.webp" },
  { name: "trees_3", texture: "./bakedPictures/trees_3.webp" },
  { name: "trees_4", texture: "./bakedPictures/trees_4.webp" },
  { name: "trees_5", texture: "./bakedPictures/trees_5.webp" },
  { name: "trees_6", texture: "./bakedPictures/trees_6.webp" },
];
